// extracted by mini-css-extract-plugin
export default {"root":"Following_root__Sh1fW","className":"Following_className__+bwZw","following_theme":"Following_following_theme__TS-4t"};